import React from "react";
import { Link } from "react-router-dom";

import services from "../../data/services";

import SectionContainer from "../common/SectionContainer";
import SectionTitle from "../common/SectionTitle";

import ServiceCard from "../cards/ServiceCard";

function ServicesPreview() {
  const featuredServices = services.filter(
    (service) => service.featured
  );

  return (
    <SectionContainer background="#f8fafc">
      <SectionTitle
        title="Services Designed Around Growth"
        subtitle="We combine consulting, marketing and technology to help businesses improve visibility, generate qualified leads and build scalable growth systems."
      />

      <div
        style={{
          display: "grid",
          gridTemplateColumns:
            "repeat(auto-fit,minmax(320px,1fr))",
          gap: "28px"
        }}
      >
        {featuredServices.map((service) => (
          <ServiceCard
            key={service.slug}
            service={service}
          />
        ))}
      </div>

      <div
        style={{
          textAlign: "center",
          marginTop: "50px"
        }}
      >
        <Link
          to="/services"
          style={{
            color: "#21b573",
            textDecoration: "none",
            fontWeight: 700,
            fontSize: "1rem"
          }}
        >
          View All Services →
        </Link>
      </div>
    </SectionContainer>
  );
}

export default ServicesPreview;